import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import Header from './Header';
import collage from '../images/collage.png'
import phoneOne from '../images/mainPhoneTwo.png'
// import phoneTwo from '../images/mainPhone.png'
import phoneThree from '../images/mainPhone.png'
import previewOne from '../images/image 42.png'
import previewTwo from '../images/image 43.png'
import previewThree from '../images/image 41.png'
import downPreview from '../images/downpreview.png'
import apple from '../images/apple.png'
import google from '../images/google.png'
import appleLogo from '../images/appleLogo.png'
import googleLogo from '../images/playLogo.png'
import stepOne from '../images/step1.png'
import stepTwo from '../images/step2.png'
import stepThree from '../images/step3.png'
import ImageCarousel from './ImageCarousel';
import twoPhones from '../images/twoPhones.png'
import myPic from '../images/fineboy.jpg'
import steps from '../images/threeSteps.png'

//images display import
import displayOne from '../images/displayone.jpeg'
import displayTwo from '../images/displaytwo.jpeg'
import displayThree from '../images/displaythree.jpeg'
import displayFour from '../images/displayfour.jpeg'
import displayFive from '../images/displayfive.jpeg'
import displaySix from '../images/displaysix.jpeg'
import displaySeven from '../images/displayseven.jpeg'
import displayEight from '../images/displayeight.jpeg'
import displayNine from '../images/displaynine.jpeg'
import displayTen from '../images/displayten.jpeg'
import displayEleven from '../images/displayeleven.jpeg'
import displayTwelve from '../images/displaytwelve.jpeg'
import displayThirteen from '../images/displaythirteen.jpeg'
import displayFourteen from '../images/displayfourteen.jpeg'
import displayFifteen from '../images/displayfifteen.jpeg'
import jacob from '../images/jacob.jpg'

import theGif from '../images/main.gif'



import Watchlist from './Watchlist';
import Contact from './Contact';
import FAQ from './FAQ';
import faqData from './faqData.js'

import pitchdeck from '../pitchdeck.pdf'


const imageArray = [displayFour, displayFive, displayOne, displayTwo, displayFifteen, displayThree,  displaySix, displaySeven, displayEight, displayNine, displayEleven, displayTen, jacob,  displayTwelve, displayThirteen, displayFourteen];



export default function Home() {

	const isTabletOrLarger = useMediaQuery('(min-width:601px)');

	const [scrollDirection, setScrollDirection] = useState(null);

	useEffect(() => {
		const handleScroll = () => {
		const scrollTop = window.scrollY;
		if (scrollTop > 0) {
			setScrollDirection('down');
		} else {
			setScrollDirection('up');
		}
		};

		window.addEventListener('scroll', handleScroll);

		// Cleanup the scroll event listener
		return () => {
		window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<div>
			<div className="intro-div">
				
                <Header/>
				{isTabletOrLarger ? 
					<p className="appear">Buy or Bid on Art & Jewellery—Own the Lifestyle.</p>
				:	<p className="appear">Buy or Bid on Art & Jewellery <br/> Own the Lifestyle.</p>
				}

				<p className="appear intro-text" style={{fontFamily: 'Inter', fontWeight: '300', fontSize: '18px', marginTop: '-20px', marginBottom: '40px'}}> Social Media & Marketplace for collectors and enthusiasts</p>

				<div>
					<a className="download-link-header" href='#testApp'><span className="header-download" style={{fontFamily: 'Inter', fontWeight: '400', fontSize: '15px'}}>Test Prototype</span></a>
				</div>
				<ImageCarousel images={imageArray} />

				{/* <img src={collage} className="collage appear"/> */}
				
			</div>

			<p className="appear liveit">
					Live It Beyond Compare.
			</p>

			<div className="phones-flex">
				<div className='appearLeft'>
					<img src={phoneOne} alt="Phone diagram" className="phones"/>
				</div>
				<div className={`phoneScroll ${scrollDirection === 'down' ? 'scroll-down' : 'scroll-up'}`}>
					<img src={theGif} alt="Phone diagram" className="phones phonesTwo"/>
				</div>
				<div className='appearRight'>
					<img src={phoneThree} alt="Phone diagram" className="phones"/>
				</div>
			</div>

			{isTabletOrLarger ? null 
			: <p className="phone-own appearBottom">Own the Real Item <br/> <span className="v-brown">Direct From Your</span> Favourite Creator, <br/> <span className="v-brown">to your</span> Doorstep.</p>
			}

			<section className="app-info">
				<div className="app-info-flex">
						<div className="app-info-img-div">
							<img src={previewOne} className="previewImage appearLeft" alt="App Preview"/>
						</div>

						<div className="app-info-info-div appearRight">
							<h2>
								Seamless Sales & Auctions
							</h2>
							<p>
								Easily upload videos and pictures of your jewelry or art, add a sale price or starting bid price, 
								and let interested buyers buy your product or place their bids in real-time. You can customize auction durations, 
								set reserve prices, and manage your listings at a glance. Once the timer ends or you accept a winning offer, the item 
								is marked as sold, making the entire auction process swift and hassle-free.
							</p>
						</div>
				</div>

				<div className="app-info-flex">
				{isTabletOrLarger ? 
					<>
						<div className="app-info-info-div right">
							<h2 className='appearRight appearLeft'>
								Social Engagement
							</h2>
							<p className='appearLeft'>
								Connect with collectors and fellow creatives through photo and video feeds designed to highlight your work. 
								Followers can like, comment, and share your posts, keeping the conversation alive and giving your creations broader visibility. 
								This social interaction creates a thriving community, where each unique piece can spark inspiration, collaboration, and potential sales.
							</p>
						</div>

						<div className="app-info-img-div">
							<img src={previewTwo} className="previewImage appearRight" alt="App Preview"/>
						</div>
					</>
				:
					<>
						<div className="app-info-img-div">
							<img src={previewTwo} className="previewImage appearLeft" alt="App Preview"/>
						</div>

						<div className="app-info-info-div right">
							<h2 className='appearRight'>
								Social Engagement
							</h2>
							<p className='appearRight'>
								Connect with collectors and fellow creatives through photo and video feeds designed to highlight your work. 
								Followers can like, comment, and share your posts, keeping the conversation alive and giving your creations broader visibility. 
								This social interaction creates a thriving community, where each unique piece can spark inspiration, collaboration, and potential sales.
							</p>
						</div>
					</>
				}	
				</div>

				<div className="app-info-flex">
					<div className="app-info-img-div">
						<img src={previewThree} className="previewImage appearLeft" alt="App Preview"/>
					</div>

					<div className="app-info-info-div appearRight">
						<h2>
							Secure Transactions & Hand to Hand Delivery
						</h2>
						<p>
							Accept payments from sales and winning bidders directly within the app via trusted payment gateways, 
							ensuring a smooth checkout experience without ever leaving the platform. Once the sale is finalized, arrange shipping or pickup through 
							our integrated delivery options to get your items safely to their new homes—or to receive incoming pieces right at your doorstep. 
							Encrypted data protects your sensitive information, letting you buy and sell with complete peace of mind.
						</p>
					</div>
				</div>

			</section>
			<section id='testApp'>
				<div style={{textAlign: 'center', marginTop: '50px'}}>
					<h1 className="prototype-title appear" style={{fontSize: '45px', fontWeight: 'bold', paddingTop: '30px'}}>Try Our Prototype</h1>

					<p className="appear" style={{fontFamily: 'Inter', fontWeight: '400', fontSize: '18px', marginBottom: '70px', marginTop: '-10px'}}>Experience the platform firsthand in just three simple steps</p>

					<img src={steps} alt="Three Steps" className='threestepsImg'/>
					<div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '-50px'}} className='stepsImg-div'>
						<a href='https://apps.apple.com/ca/app/testflight/id899247664'>
							<img src={stepOne} alt="Step 1" className='stepsImg appearLeft'/>
						</a>

						<a href='https://testflight.apple.com/join/ja57Cwhr'>
							<img src={stepTwo} alt="Step 2" className='stepsImg appear'/>
						</a>

						<a href=''>
							<img src={stepThree} alt="Step 3" className='stepsImg stepsImg-sign appearRight'/>
						</a>

					</div>
				</div>
			</section>

			<section className='joinOne'>
				<div>
					<h1 className="appear">
						Join Us in Building the Future of Luxury Commerce
					</h1>

					<p style={{marginBottom: '35px', fontFamily: 'Inter', fontWeight: '200', fontSize: '18px'}} className="appear">
						We're seeking investors, co-founders, and strategic partners to help launch and
						scale our platform. Your support will accelerate product completion, user
						acquisition, and operational excellence.
					</p>

					<div style={{marginTop: '50px'}} className="appear">
						<a className="download-link-header" href="/partner"><span className="header-download">Invest Now</span></a>
					</div>
				</div>
			</section>

			<section className='vision'>

				<div style={{display:'flex', flexWrap:'wrap'}} className='vision-flex'>
					<div>
						<img src={myPic} alt="Collage" className="vision-img appearLeft" style={{width: '400px', height: 'auto'}}/>
					</div>

					<div className='vision-text'>
						<h1 className='appearRight'>
							Our Vision
						</h1>

						<p className='appearRight'>
							To create a premium, community-driven platform that
							celebrates art, empowers sellers, and delights buyers
							worldwide.
						</p>

						<p className='appearRight'>
							We believe in the power of connection—bringing together
							passionate collectors, talented artisans, and discerning
							buyers in a space that honors craftsmanship, authenticity,
							and the timeless beauty of luxury goods.
						</p>

						<div className='join-vision-btn appearRight'>
							<a className="download-link-header"><span className="header-download">Join Our Journey</span></a>
						</div>
					</div>
				</div>

			</section>
			

			<Watchlist/>


			<section className='first-section'>
				<div style={{display:'flex', flexWrap:'wrap'}} className='first-flex'>
					<div className='first-text'>
						<h1 className='appearLeft'>Be the First to Experience Our App</h1>
						<p className='appearLeft'>Experience a curated luxury art and jewellery marketplace. Get early access and explore exclusive collections before launch.</p>
					</div>

					<div>
						<img src={twoPhones} alt="Collage" className="first-img appearRight"/>
					</div>
				</div>
			</section>

			<section className='pitch-section'>
				<h1 className='appear'>
					View Our Pitch Deck
				</h1>

				<p className='appear'>
					Explore our vision, market opportunity, business model, and growth strategy in detail
				</p>
				
				<div className='appear'>
					<a className="download-link-header" href={pitchdeck} target='_blank'><span className="header-download">Open Pitch Deck</span></a>
				</div>
			</section>


			<FAQ items={faqData} />

			<Contact />

			{/* <div className="download-flex">
				<div>
					<h2 className='appearTop'> Download </h2>
					<h2 className="h2-2 appearBottom"> N<span className="v-brown">V</span></h2>
					<a>
						<div className="download-btn">
							<div>
								<img src={appleLogo} />
							</div>
							<div>
								Download on the <br/>
								<h2>App Store</h2>
							</div>
						</div>
					</a>

					<a>
						<div className="download-btn">
							<div>
								<img src={googleLogo} />
							</div>
							<div>
								GET IT ON <br/>
								<h2>Google Play</h2>
							</div>
						</div>
					</a>
					<a className='appearBottom '><img src={apple} alt="Download with Apple" className="download-GA"/></a> <a className='appearBottom '><img src={google} alt="Download with Google" className="download-GA google"/></a>
				</div>

				<div className='appear'>
					<img src={downPreview} alt="Download Image preivew"/>
					
				</div>
			</div> */}
		</div>
	)
}

